import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { postNew } from "../../service/api";

export default function AddNewPostModal({ isOpen, setIsOpen }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [caption, setCaption] = useState("");
  const [fees, setFees] = useState(0);
  const [picture, setPicture] = useState();

  useEffect(async () => {
    const data = JSON.parse(sessionStorage.getItem("creatordata"));

    setEmail(data.email);
    setName(data.name);
  });

  const navigate = useNavigate();
  const pictureRef = useRef();
  const pictureInputRef = useRef();

  const capturePicture = (e) => {
    const url = URL.createObjectURL(e.target.files[0]);
    pictureRef.current.src = url;
    setPicture(e.target.files[0]);
  };

  function closeModal() {
    setIsOpen(false);
  }

  const onSubmit = async (e) => {
    let formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("caption", caption);
    formData.append("fees", fees);
    formData.append("picture", picture);
    await postNew(formData);
    navigate("/creator/gallery");
    closeModal();
    window.location.reload();
  };

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <form
                  className="flex flex-col gap-5"
                  style={{ color: "black" }}
                >
                  <div className="w-full flex flex-col gap-2">
                    <label htmlFor="picture">Image:</label>
                    <input
                      type="file"
                      name="picture"
                      id="picture"
                      ref={pictureInputRef}
                      onChange={(e) => capturePicture(e)}
                      className="w-full border border-gray-400 px-3 py-2 rounded-lg focus:outline-none focus:border-blue-600"
                    />
                    <img
                      src=""
                      alt=""
                      ref={pictureRef}
                      className="w-40 h-40 rounded-lg"
                    />
                  </div>
                  <div className="w-full flex flex-col gap-2">
                    <label htmlFor="caption">Caption:</label>
                    <input
                      type="caption"
                      id="caption"
                      className="w-full border border-gray-400 px-3 py-2 rounded-lg focus:outline-none focus:border-blue-600"
                      onChange={(e) => {
                        setCaption(e.target.value);
                      }}
                    />
                  </div>
                  <div className="w-full flex flex-col gap-2">
                    <label htmlFor="fees">Fees:</label>
                    <input
                      type="fees"
                      id="fees"
                      className="w-full border border-gray-400 px-3 py-2 rounded-lg focus:outline-none focus:border-blue-600"
                      onChange={(e) => {
                        setFees(e.target.value);
                      }}
                    />
                  </div>
                  <button
                    className="w-full hover:cursor-pointer text-center bg-blue-600 text-white py-2 rounded-lg"
                    onClick={(e) =>{
                      e.preventDefault();
                      onSubmit(e);
                    }}
                  >
                    Post
                  </button>
                </form>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
